// import { useNavigate } from "react-router-dom";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import darkLogo from "../../../images/logo-black.png";
import lightLogo from "../../../images/logo-white.png";
import { Link } from "react-router-dom";
import {
  RiShieldLine,
  RiLockLine,
  RiUserSettingsLine,
  RiFileListLine,
  RiRefreshLine,
} from "react-icons/ri";

const SafetyAndSecurity = ({ mode = "light" }) => {
  // const navigate = useNavigate();

  return (
    <div>
      <div className="relative container mx-auto max-w-screen-2xl">
        <Header mode="light" className="border-b border-gray-3" />

        <div className="flex flex-col mt-10 md:mt-[54px] mb-8 md:mb-[76px] px-6 md:px-[48px] lg:px-[128px]">
          <h1 className="font-[900] md:font-extrabold text-[32px] md:text-[50px] leading-[38px] md:leading-[52px] text-black text-center mb-6 md:mb-10">
            Safety & Security
          </h1>

          <div className="flex flex-col gap-6 md:gap-8 mb-10">
            {/* Introduction */}
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-500">
              <h2 className="font-bold text-xl md:text-2xl mb-3 text-gray-800">
                Our Commitment to Your Protection
              </h2>
              <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                At Unspokenn, your safety and security are our highest
                priorities. We've designed our platform with robust protective
                measures to ensure your anonymity while providing a secure
                channel for reporting incidents. Our commitment extends beyond
                just technical security—we aim to create a trusted environment
                where individuals can speak up without fear of repercussions.
              </p>
            </div>

            {/* Anonymous Reporting Technology */}
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <RiShieldLine className="w-6 h-6 mr-2 text-blue-600" />
                <h2 className="font-bold text-lg md:text-xl text-gray-800">
                  Anonymous Reporting Technology
                </h2>
              </div>

              <div className="pl-8 space-y-4">
                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    End-to-End Encryption
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    All reports submitted through Unspokenn are protected with
                    end-to-end encryption, ensuring that your information
                    remains secure from the moment you submit it. This
                    encryption technology makes it virtually impossible for
                    unauthorized parties to access the content of your reports.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Optional Anonymity
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    Our system gives you the option to report anonymously. While
                    we do collect email and phone information for standard
                    reports, you can choose to submit anonymous reports where we
                    only request an email address for the sole purpose of
                    sending you tracking details about your report. Our system
                    also automatically removes metadata from any files you
                    upload that could contain identifying information, ensuring
                    your privacy remains protected regardless of which reporting
                    option you choose.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    IP Address Protection
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    We employ advanced IP masking techniques to ensure that your
                    network identity remains protected. Your IP address is never
                    stored in connection with your report, preventing any
                    technical tracing of submissions back to your device or
                    location.
                  </p>
                </div>
              </div>
            </div>

            {/* Data Security Practices */}
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <RiLockLine className="w-6 h-6 mr-2 text-blue-600" />
                <h2 className="font-bold text-lg md:text-xl text-gray-800">
                  Data Security Practices
                </h2>
              </div>

              <div className="pl-8 space-y-4">
                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Secure Data Storage
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    All data stored within our system is protected using
                    industry-leading security protocols. We maintain strict
                    access controls, with data compartmentalization ensuring
                    that even within our organization, access to sensitive
                    information is strictly limited to those who absolutely need
                    it.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Regular Security Audits
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    We conduct regular security audits and vulnerability
                    assessments of our platform. Independent security experts
                    evaluate our systems to identify and address potential
                    vulnerabilities before they can be exploited.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Compliance with Global Standards
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    Our security practices comply with international data
                    protection standards, including GDPR, CCPA, and other
                    relevant regulatory frameworks. We regularly review and
                    update our practices to maintain compliance with evolving
                    global standards.
                  </p>
                </div>
              </div>
            </div>

            {/* User Protection Measures */}
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <RiUserSettingsLine className="w-6 h-6 mr-2 text-blue-600" />
                <h2 className="font-bold text-lg md:text-xl text-gray-800">
                  User Protection Measures
                </h2>
              </div>

              <div className="pl-8 space-y-4">
                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Anti-Retaliation Safeguards
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    Our platform incorporates various safeguards designed to
                    protect users from potential retaliation. These include
                    controlled information flow to relevant authorities and
                    organizations, with identifying details removed.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Emergency Support
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    While Unspokenn is not an emergency response service, we
                    provide clear guidance for users facing immediate threats,
                    directing them to appropriate emergency services while
                    maintaining their anonymity on our platform.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Content Moderation
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    We employ a combination of automated systems and human
                    review to ensure that the platform is not misused for
                    harassment or spreading false information. Our moderation
                    processes are designed to maintain the integrity of the
                    reporting system while preserving user anonymity.
                  </p>
                </div>
              </div>
            </div>

            {/* Best Practices for Users */}
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <RiFileListLine className="w-6 h-6 mr-2 text-blue-600" />
                <h2 className="font-bold text-lg md:text-xl text-gray-800">
                  Best Practices for Users
                </h2>
              </div>

              <div className="pl-8 space-y-4">
                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Protecting Your Identity
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700 mb-2">
                    While using Unspokenn:
                  </p>
                  <ul className="list-disc pl-5 font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    <li>
                      Consider using a secure network connection or VPN for
                      additional privacy
                    </li>
                    <li>
                      Avoid including personally identifying details in your
                      reports
                    </li>
                    <li>
                      Be cautious about sharing unique information that could
                      identify you
                    </li>
                    <li>
                      Use the platform's built-in tools for secure communication
                      rather than external channels
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-2 text-gray-800">
                    Reporting Responsibly
                  </h3>
                  <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700 mb-2">
                    For the most effective use of our platform:
                  </p>
                  <ul className="list-disc pl-5 font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                    <li>Provide clear, factual information</li>
                    <li>
                      Focus on specific incidents rather than general complaints
                    </li>
                    <li>
                      Include relevant details while excluding unnecessary
                      personal information
                    </li>
                    <li>
                      Follow the guided reporting process to ensure all
                      necessary information is included
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Continuous Improvement */}
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <RiRefreshLine className="w-6 h-6 mr-2 text-blue-600" />
                <h2 className="font-bold text-lg md:text-xl text-gray-800">
                  Continuous Improvement
                </h2>
              </div>

              <p className="pl-8 font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                We are committed to continuously improving our safety and
                security measures. We actively monitor emerging threats and
                evolving best practices in digital security. User feedback plays
                a critical role in this process—we encourage you to share your
                concerns and suggestions about our safety features so we can
                better serve our community.
              </p>
            </div>

            {/* Contact Information */}
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-500">
              <h2 className="font-bold text-lg md:text-xl mb-3 text-gray-800">
                Contact and Support
              </h2>
              <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px] text-gray-700">
                If you have questions or concerns about safety and security on
                our platform, you can reach out to our security team at{" "}
                <span className="font-medium">security@unspokenn.com</span>. For
                general inquiries, please contact
                <span className="font-medium"> support@unspokenn.com</span>. All
                communications with our team are treated with the highest level
                of confidentiality.
              </p>
            </div>

            {/* Closing Statement */}
            <div className="italic text-center border-t border-b py-6 my-4 text-gray-700">
              <p className="font-normal text-sm md:text-base leading-[20px] md:leading-[24px]">
                At Unspokenn, we believe that true safety comes from community
                vigilance and accountability. By providing a secure platform for
                reporting incidents, we aim to empower individuals and
                contribute to creating safer environments for everyone. Your
                trust is our most valuable asset, and we remain committed to
                earning and maintaining it through rigorous security practices
                and unwavering respect for your privacy.
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center max-w-[175px] self-center">
            <Link to="/" className="">
              <img
                src={mode === "dark" ? lightLogo : darkLogo}
                className="h-[17px] md:h-[25.32px]"
                alt="unspokenn"
              />
            </Link>

            <p className="font-medium md:font-normal text-[8px] xs:text-xs leading-[11.76px] xs:leading-[14.32px] mt-3 md:mt-[18px] text-center">
              Copyright © UNSPOKEN 2024
              <br /> All Right Reserved
            </p>
          </div>
        </div>
        <Footer mode="dark" />
      </div>
    </div>
  );
};

export default SafetyAndSecurity;
